module.exports = __webpack_public_path__ + "images/external_images/img/demo/hotel/gallery-2.jpg";